import { ColDef } from "ag-grid-community";

import { GFCAvailableReports, GFCDownloadReport } from "./GridFrameworkComponents";

const reportListColumnDef: ColDef[] = [
    {
        headerName: "Available Reports",
        field: "Name",
        sortable: true,
        //filter: true,
        resizable: true,
        flex: 1,
        autoHeight: true,
        headerStyle: { paddingLeft: "24px" },
        cellStyle: { paddingLeft: "24px" },
        cellRenderer: GFCAvailableReports,
    },
    {
        headerName: "",
        field: "Id",
        cellRenderer: GFCDownloadReport,
    },
    // {
    //     headerName: "Offering Type",
    //     field: "offeringType",
    //     sortable: true,
    //     filter: true,
    //     resizable: true,
    //     cellEditor: "agSelectCellEditor",
    //     cellRenderer: GFCServiceType,
    // },
    // {
    //     headerName: "Unit Price",
    //     field: "unitPrice",
    //     sortable: true,
    //     filter: "agNumberColumnFilter",
    //     resizable: true,
    //     valueFormatter: ({ value }) => (typeof value === "number" ? `$${value.toFixed(2)}` : value),
    // },
    // {
    //     headerName: "Available Units",
    //     field: "availableUnits",
    //     sortable: true,
    //     filter: "agNumberColumnFilter",
    //     resizable: true,
    // },
    // {
    //     headerName: "",
    //     field: "availableUnits",
    //     width: 100,
    //     cellRenderer: GFCMoreOptions,
    //     cellClass: "no-outline-cell", // Apply custom class
    // },
];

export { reportListColumnDef };
